import { IonButton, IonButtons, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonInput, IonLabel, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import "./TaxaServico.css";


type Props = {
  projetoid: string;
  valorInicial?: number | string;
  modalAberto?: boolean;
  closeAction: (taxaServico: string) => void | Promise<void>;
  closeActionSimple: () => void;
};

const VALORES_RAPIDOS_TAXA = [0, 10, 12, 15];

const limitarTaxaServico = (valor: number) => Math.max(0, Math.min(100, Math.round(valor)));

const normalizarTaxaServicoInicial = (valorInicial?: number | string) => {
  if (typeof valorInicial === 'number') {
    return limitarTaxaServico(valorInicial);
  }

  if (typeof valorInicial === 'string') {
    const valorNumerico = Number.parseInt(valorInicial.replace(/\D/g, ''), 10);
    return Number.isFinite(valorNumerico) ? limitarTaxaServico(valorNumerico) : 0;
  }

  return 0;
};

const TaxaServico: React.FC<Props> = (props: Props) => {

  const [taxaServico, setTaxaServico] = useState(0);
  const [inputTaxaServico, setInputTaxaServico] = useState('0');

  useEffect(() => {
    if (props.modalAberto === false) {
      return;
    }

    const taxaInicial = normalizarTaxaServicoInicial(props.valorInicial);
    setTaxaServico(taxaInicial);
    setInputTaxaServico(String(taxaInicial));
  }, [props.modalAberto, props.valorInicial]);


  function selecionarTaxa(valor: number) {
    const taxa = limitarTaxaServico(valor);
    setTaxaServico(taxa);
    setInputTaxaServico(String(taxa));
  }

  function onFocusInput() {
    setInputTaxaServico(taxaServico ? String(taxaServico) : '');
  }

  function onBlurInput() {
    setInputTaxaServico(String(taxaServico));
  }

  function obterValorInput(event: any) {
    return String(event?.target?.value ?? event?.detail?.value ?? '');
  }

  function onChangeValor(event: any) {
    const valorDigitado = obterValorInput(event).replace(/\D/g, '').slice(0, 3);

    if (!valorDigitado) {
      setInputTaxaServico('');
      setTaxaServico(0);
      return;
    }

    const taxa = limitarTaxaServico(Number(valorDigitado));
    setTaxaServico(taxa);
    setInputTaxaServico(String(taxa));
  }

  return (

    <>
      <IonHeader className="ion-no-border">
        <IonToolbar color="primary">

          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => {
              props.closeActionSimple();
            }} />
          </IonButtons>
          <IonTitle>Taxa de Serviço</IonTitle>

        </IonToolbar>

      </IonHeader>

      <IonContent className="TaxaServico" fullscreen={false}>

        <IonGrid >
          <IonRow className="ion-justify-content-center" style={{ paddingTop: '20px', textAlign: 'center', fontSize: '20px' }}>
            <IonLabel>Selecione uma taxa de serviço ou insira manualmente</IonLabel>
          </IonRow>

          <IonRow className="ion-justify-content-center" style={{ paddingTop: '20px' }}>
            <div className="TaxaServico__quickButtons">
              {VALORES_RAPIDOS_TAXA.map((valor) => (
                <IonButton
                  key={valor}
                  className="TaxaServico__quickButton"
                  color={taxaServico === valor ? 'primary' : 'light'}
                  onClick={() => selecionarTaxa(valor)}
                >
                  {valor}%
                </IonButton>
              ))}
            </div>
          </IonRow>

          <IonRow className="ion-justify-content-center" style={{ paddingTop: '20px', textAlign: 'center', fontSize: '26px' }}>
            <IonCol className="TaxaServico__inputCol" size="6">
              <div className="TaxaServico__inputWrapper">
                <IonInput
                  className="TaxaServico__input"
                  type="tel"
                  inputmode="numeric"
                  maxlength={3}
                  placeholder="0"
                  value={inputTaxaServico}
                  onIonInput={onChangeValor}
                  onIonFocus={onFocusInput}
                  onIonBlur={onBlurInput}
                />
                <span className="TaxaServico__inputSuffix">%</span>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>

      <IonFooter>

        <IonToolbar className="TaxaServico">
          <IonGrid>

            <IonRow>
              <IonCol size="12">
                <IonButton style={{ height: "46px", fontSize: "18px" }} expand="block"
                  type="submit"
                  onClick={async () => {
                    await props.closeAction(String(taxaServico));
                  }}
                >
                  Salvar
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>

        </IonToolbar>
      </IonFooter>
    </>

  );
};

const TaxaServicoModal = ({ projetoid, valorInicial, modalAberto, closeAction, closeActionSimple }: { projetoid: string, valorInicial?: number | string, modalAberto?: boolean, closeAction: (taxaServico: string) => void | Promise<void>, closeActionSimple: () => void }) => (
  <TaxaServico projetoid={projetoid} valorInicial={valorInicial} modalAberto={modalAberto} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </TaxaServico>
);

export default TaxaServicoModal;
